// @flow
import { createSelector } from '@reduxjs/toolkit';
import { LOAD_SIMILAR_ITEMS_SUCCESS } from './actions';
import cloneDeep from 'lodash/cloneDeep';
import type { GlobalState } from '../rootReducer';

/* reducer */
export const DEFAULT_STATE = {
    byId: {},
    loaded: {},
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOAD_SIMILAR_ITEMS_SUCCESS:
            const existing = cloneDeep(state.byId);
            action.payload.forEach(({ categories, itemId }) => {
                existing[itemId] = categories;
            });
            return {
                ...state,
                byId: existing,
                loaded: {
                    ...state.loaded,
                    [action.meta.itemId]: action.meta.actionTime,
                },
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.similarItemsCategories;

const idSelector = (state, id) => id;

const byIdSelector = createSelector(stateSelector, (state) => state.byId);

export const getSimilarItemCategories = createSelector([byIdSelector, idSelector], (byId, id) => byId[id] || []);
